if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.preorderThreshold();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
              quickAddModal.querySelectorAll('.quick-add-modal__content').forEach((quickAdd)=>{
                quickAdd.classList.remove('overflow-hidden');
              })
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      preorderThreshold() {
          this.cartJSON();
          setTimeout(() => {
              let cartItemList = JSON.parse(document.getElementById('cart-variant-json')?.textContent || '[]');
              this.handlePreorderThreshold(cartItemList);
              console.log('json updated vie cart update', cartItemList)
          }, 1000);
          subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
              this.cartJSON();
              console.log(event);
              setTimeout(() => {
                  const cartItemList = JSON.parse(document.getElementById('cart-variant-json')?.textContent || '[]');
                  this.handlePreorderThreshold(cartItemList);
                  console.log('json updated vie cart update', cartItemList)
              }, 1000);
          });
          subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
            console.log(event);
              setTimeout(() => {
                  const cartItemList = JSON.parse(document.getElementById('cart-variant-json')?.textContent || '[]');
                  this.handlePreorderThreshold(cartItemList);
                  console.log('json updated vie varinat change', cartItemList)
              }, 2000);
          });
      }

      cartJSON() {
          fetch(`${window.Shopify.routes.root}cart.js`)
              .then(res => res.json())
              .then(cart => {
                  if (!cart || !cart.items) return;

                  const cartItemList = cart.items.map(item => ({
                      variant_id: item.variant_id,
                      variant_qty: item.quantity
                  }));

                  const jsonString = JSON.stringify(cartItemList);

                  let script = document.getElementById('cart-variant-json');

                  if (!script) {
                      script = document.createElement('script');
                      script.id = 'cart-variant-json';
                      script.type = 'application/json';
                      document.body.appendChild(script);
                  }

                  if (script.textContent !== jsonString) {
                      script.textContent = jsonString;
                  }
              })
              .catch(err => {
                  console.error('Cart JSON update failed:', err);
              });
      }

      handlePreorderThreshold(cartVariants) {
          let addedVariantID = Number(document.querySelector('.variant-selects-box')?.getAttribute('preorder-variant-id'));
          if (!addedVariantID) return;
          let productThresholdDisclaimer = document.querySelector('.preorder-threshold-disclaimer');
          let variantThreshold = Number(document.querySelector('.variant-selects-box')?.getAttribute('preorder-variant-threshold'));
          if (!variantThreshold || !productThresholdDisclaimer) return;

          console.log(cartVariants);

          const matchedVariant = (cartVariants || []).some(
              v => v.variant_id == addedVariantID
          );

          console.log('matchedVariant', matchedVariant);

          if (!matchedVariant) {
              productThresholdDisclaimer.classList.add('hidden');
              this.querySelector('.product-form__submit')?.removeAttribute('disabled');
              return;
          }

          (cartVariants || []).forEach(cartVariant => {
              if (cartVariant.variant_id == addedVariantID) {
                  if (cartVariant.variant_qty >= variantThreshold) {
                      productThresholdDisclaimer.classList.remove('hidden');
                      this.querySelector('.product-form__submit')?.setAttribute('disabled', true);
                  } else {
                      productThresholdDisclaimer.classList.add('hidden');
                      this.querySelector('.product-form__submit')?.removeAttribute('disabled');
                  }
              }
          });
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
